module.exports = __webpack_public_path__ + "static/media/grimmjow.88426f40.png";